/**
 * Service for cost center enable/disable operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';


export class CostCenterEnableDisableService {
  async enable(costCenterId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.ENABLE_COST_CENTER(costCenterId);

    return await apiClient.patch<null>(endpoint, {});
  }

  async disable(costCenterId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.DISABLE_COST_CENTER(costCenterId);

    return await apiClient.patch<null>(endpoint, {});
  }
}

export const costCenterEnableDisable = new CostCenterEnableDisableService();
